import React from 'react';
import '../../GameEndContent/GameEndPlayerInfo/GameEndPlayerInfo.css';
import {getPlayerHexColor} from "../../../utils/players/getPlayerHexColor";
import {resolveFactionSkinIconPath} from "../../../utils/factions/resolveFactionSkinIconPath";
import {checkIfBotMarkShown} from "../../../utils/bots/checkIfBotMarkShown";
import RankSkinFrame from "../../RankSkinFrame/RankSkinFrame";
import VisibleBotMark from "../../VisibleBotMark/VisibleBotMark";
import {WinPointsStat} from "../../PlayerStat/stats/WinPointsStat";
import {CoinsStat} from "../../PlayerStat/stats/CoinsStat";
import {MINUS_SIGN} from "../../../constants/text";

const CITY_ICON = '/img/icons/city.42008716.png';

// Число со знаком: «+3», «−2», «0»
export const formatSignedNumber = (value) => {
  if (value > 0) {
    return `+${value}`;
  }
  if (value < 0) {
    return `${MINUS_SIGN}${Math.abs(value)}`;
  }
  return '0';
};

/**
 * Строка игрока в модалке захвата — та же плашка, что в итогах раунда
 * (рамка цвета игрока, портрет со срезанными углами, ник его цветом), а
 * справа: сколько городов он захватил и потерял, сколько очков принес ему
 * захват и как изменился его доход за раунд — монет и очков
 * @param {Object} row - строка buildCityCaptureRows
 */
const CityCaptureStatsRow = ({row}) => {
  const {player, capturedCount, lostCount, winPointsDelta, coinsIncomeDelta, winPointsIncomeDelta} = row;
  const playerHexColor = getPlayerHexColor(player.color);
  const isIncomeKnown = typeof coinsIncomeDelta === 'number' && typeof winPointsIncomeDelta === 'number';

  return (
    <div
      className="game-end-player-info city-capture-player"
      style={{borderLeftColor: playerHexColor}}
    >
      <div className="game-end-player-icon city-capture-player_icon">
        <img
          className={'side-menu_faction-icon'}
          src={resolveFactionSkinIconPath(player.factionId, player.selectedSkin)}
          alt={player.factionId}
        />
        <RankSkinFrame skinId={player.selectedSkin}/>
        {checkIfBotMarkShown(player) && <VisibleBotMark player={player}/>}
      </div>

      <div className="game-end-player-name city-capture-player_name" style={{color: playerHexColor}}>
        <span className="game-end-player-name-text" title={player.name}>{player.name}</span>
      </div>

      <div className="city-capture-player_cities">
        {capturedCount > 0 && (
          <span
            className="city-capture-player_cities-count city-capture-player_delta-up"
            title={`Захвачено городов: ${capturedCount}`}
          >
            <img src={CITY_ICON} alt={''}/>
            {formatSignedNumber(capturedCount)}
          </span>
        )}
        {lostCount > 0 && (
          <span
            className="city-capture-player_cities-count city-capture-player_delta-down"
            title={`Потеряно городов: ${lostCount}`}
          >
            <img src={CITY_ICON} alt={''}/>
            {formatSignedNumber(-lostCount)}
          </span>
        )}
      </div>

      <div className="city-capture-player_points" title={'Очки за захват'}>
        <WinPointsStat
          className={'city-capture-player_points-stat'}
          text={formatSignedNumber(winPointsDelta)}
          isDarkColor={true}
          noShrinkOnMobile={true}
        />
      </div>

      <div className="city-capture-player_income" title={'Изменение дохода за раунд'}>
        {isIncomeKnown ? (
          <>
            <CoinsStat
              className={'city-capture-player_income-stat'}
              text={formatSignedNumber(coinsIncomeDelta)}
              isDarkColor={true}
              noShrinkOnMobile={true}
            />
            <WinPointsStat
              className={'city-capture-player_income-stat'}
              text={formatSignedNumber(winPointsIncomeDelta)}
              isDarkColor={true}
              noShrinkOnMobile={true}
            />
          </>
        ) : null}
      </div>
    </div>
  );
};

export default CityCaptureStatsRow;
